import { ref, computed, onMounted, onUnmounted } from 'vue'

/**
 * Viewport composable to abstract window size access
 * Provides reactive window dimensions and breakpoint helpers
 */
export function useViewport() {
  const height = ref(window.innerHeight)
  const width = ref(window.innerWidth)
  
  const updateSize = () => {
    height.value = window.innerHeight
    width.value = window.innerWidth
  }
  
  onMounted(() => {
    window.addEventListener('resize', updateSize)
  })
  
  onUnmounted(() => {
    window.removeEventListener('resize', updateSize)
  })
  
  // Breakpoint helpers based on the original BaseModal logic
  const isLargeScreen = computed(() => height.value > 667)
  const isDesktopScreen = computed(() => height.value >= 928)
  
  // Modal breakpoints calculation (extracted from BaseModal)
  const modalBreakpoints = computed(() => {
    const smallMobileBreakpoints = [0, 0.25, 0.5, 0.65, 0.8, 1]
    const largeMobileBreakpoints = [0, 0.25, 0.5, 0.65]
    const desktopOrTabletBreakpoints = smallMobileBreakpoints

    if (isDesktopScreen.value) {
      return desktopOrTabletBreakpoints
    } else if (isLargeScreen.value) {
      return largeMobileBreakpoints
    } else {
      return smallMobileBreakpoints
    }
  })
  
  return { 
    height, 
    width, 
    isLargeScreen, 
    isDesktopScreen,
    modalBreakpoints
  }
} 